import React, { useEffect, useState } from 'react';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { useCurrentOrganization } from 'src/store/organization';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { apiUpdateOrganizationSettings } from 'src/utils/journeyApi';
import { OrganizationSettings } from 'src/common/interfaces/organization_settings.interface';

export const DashboardSettingsJourneyBehavior = () => {
  const { setErrorNotification } = useNotificationMessage();
  const currentOrganization = useCurrentOrganization((state) => state.currentOrganization);
  const setCurrentOrganization = useCurrentOrganization((state) => state.setCurrentOrganization);
  const [journeyEmailRequired, setJourneyEmailRequired] = useState<boolean>(currentOrganization.settings.journey_email_required);
  const [journeyEmailVerificationRequired, setJourneyEmailVerificationRequired] = useState<boolean>(currentOrganization.settings.journey_email_verification_required);

  const updateSettings = (emailRequired: boolean, emailVerificationRequired: boolean) => {
    apiUpdateOrganizationSettings(currentOrganization.id, {
      journey_email_required: emailRequired,
      journey_email_verification_required: emailVerificationRequired,
    })
      .then((settings: OrganizationSettings) => {
        const { journey_email_required, journey_email_verification_required } = settings;
        setJourneyEmailRequired(journey_email_required);
        setJourneyEmailVerificationRequired(journey_email_verification_required);
        setCurrentOrganization({ ...currentOrganization, settings });
      })
      .catch(() => {
        setErrorNotification('An error occurred');
      });
  };

  return (
    <div className='flex flex-col gap-6'>
      <ToggleComponent
        groupClassName='w-fit'
        labelType='strong'
        label='Require email to view'
        subText='All recipients will need to enter an email address before viewing a Journey - this change only affects newly created Journeys'
        checked={journeyEmailRequired}
        disabled={journeyEmailVerificationRequired}
        onChange={(value) => {
          updateSettings(value, journeyEmailVerificationRequired);
        }}
      />
      <ToggleComponent
        groupClassName='w-fit'
        labelType='strong'
        label='Require emails to be verified'
        subText='All recipients will need to verify their emails (with an access code we send them) before viewing a Journey - this change only affects newly created Journeys'
        checked={journeyEmailVerificationRequired}
        onChange={(value) => {
          if (value === true) {
            updateSettings(true, true);
          } else {
            updateSettings(journeyEmailRequired, false);
          }          
        }}
      />
    </div>
  );
};
